import { useCallback, useRef } from 'react';

/**
 * Lets a fetch tell whether a newer one has started since, so a slow, stale
 * response can't overwrite newer data (or the date-range label above it).
 *
 *   const beginRequest = useLatestRequest();
 *   const isLatest = beginRequest();
 *   const res = await adminApi.something();
 *   if (!isLatest()) return;
 *
 * `beginRequest` keeps the same identity across renders.
 */
export function useLatestRequest(): () => () => boolean {
  const latest = useRef(0);
  return useCallback(() => {
    const mine = ++latest.current;
    return () => mine === latest.current;
  }, []);
}
